import { Component, Input, OnInit } from '@angular/core';
import { Toastable } from '../../util/toast-container/toast-container.types';
import { Subject } from 'rxjs';
import { Product } from 'src/app/api/contracts/product';
import { NavController } from '@ionic/angular';
import { OrderType } from 'src/app/api/contracts/order';

@Component({
  selector: 'app-scanned-product-toast',
  templateUrl: './scanned-product-toast.component.html',
  styleUrls: ['./scanned-product-toast.component.scss'],
})
export class ScannedProductToastComponent
  implements OnInit, Toastable<boolean>
{
  readonly dismissAsToast = new Subject<boolean>();

  @Input() product!: Product;

  constructor(private readonly navCtrl: NavController) {}

  ngOnInit() {
    return;
  }

  openDetails(): void {
    this.dismissAsToast.next(false);
    this.navCtrl.navigateForward(`store/product/${this.product.id}`, {
      queryParams: {
        type: OrderType.IN_STORE,
      },
      state: {
        product: this.product,
        isOpenedAfterScanningBarcode: true,
      },
    });
  }
}
